class ShouldIWornBy {
  constructor(section) {
    this.section = section;
    this.lightbox = section.querySelector('[data-worn-by-lightbox]');
    if (!this.lightbox) return;

    this.slides = [...this.lightbox.querySelectorAll('[data-worn-by-slide]')];
    this.openers = [...section.querySelectorAll('[data-worn-by-open]')];
    this.closeButtons = [...this.lightbox.querySelectorAll('[data-worn-by-close]')];
    this.previousButton = this.lightbox.querySelector('[data-worn-by-prev]');
    this.nextButton = this.lightbox.querySelector('[data-worn-by-next]');
    this.stage = this.lightbox.querySelector('[data-worn-by-stage]');
    this.counter = this.lightbox.querySelector('[data-worn-by-current]');
    this.currentIndex = 0;
    this.trigger = null;
    this.touchStartX = null;

    this.onKeydown = this.onKeydown.bind(this);
    this.openers.forEach((button) => {
      button.addEventListener('click', () => this.open(Number(button.dataset.wornByIndex || 0), button));
    });
    this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));
    this.previousButton?.addEventListener('click', () => this.show(this.currentIndex - 1));
    this.nextButton?.addEventListener('click', () => this.show(this.currentIndex + 1));
    this.stage?.addEventListener('touchstart', (event) => {
      this.touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    this.stage?.addEventListener('touchend', (event) => this.onTouchEnd(event), { passive: true });
  }

  open(index, trigger) {
    this.trigger = trigger;
    this.show(index);
    this.lightbox.hidden = false;
    document.documentElement.classList.add('shouldi-worn-by-is-open');
    document.addEventListener('keydown', this.onKeydown);
    this.lightbox.querySelector('[data-worn-by-close]')?.focus();
  }

  close() {
    if (this.lightbox.hidden) return;
    this.lightbox.hidden = true;
    document.documentElement.classList.remove('shouldi-worn-by-is-open');
    document.removeEventListener('keydown', this.onKeydown);
    this.trigger?.focus();
  }

  show(nextIndex) {
    if (!this.slides.length) return;
    this.currentIndex = (nextIndex + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, index) => {
      const isActive = index === this.currentIndex;
      slide.hidden = !isActive;
      slide.classList.toggle('is-active', isActive);
    });
    if (this.counter) this.counter.textContent = String(this.currentIndex + 1);
  }

  onTouchEnd(event) {
    if (this.touchStartX === null) return;
    const endX = event.changedTouches[0]?.clientX ?? this.touchStartX;
    const delta = endX - this.touchStartX;
    this.touchStartX = null;
    if (Math.abs(delta) < 48) return;
    this.show(this.currentIndex + (delta < 0 ? 1 : -1));
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
      return;
    }
    if (event.key === 'ArrowLeft') {
      this.show(this.currentIndex - 1);
      return;
    }
    if (event.key === 'ArrowRight') {
      this.show(this.currentIndex + 1);
      return;
    }
    if (event.key !== 'Tab') return;

    const focusable = [...this.lightbox.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.hidden);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}

const initializeShouldIWornBy = (root = document) => {
  root.querySelectorAll('[data-shouldi-worn-by]').forEach((section) => {
    if (section.dataset.wornByInitialized === 'true') return;
    section.dataset.wornByInitialized = 'true';
    new ShouldIWornBy(section);
  });
};

document.addEventListener('DOMContentLoaded', () => initializeShouldIWornBy());
document.addEventListener('shopify:section:load', (event) => initializeShouldIWornBy(event.target));
